import { Icon } from '@mairistem/finances-utils';
import type React from 'react';

interface ZoomButtonProps {
	onClick: VoidFunction;
	alwaysVisible?: boolean;
}

const ZoomButton = ({ onClick, alwaysVisible = false }: ZoomButtonProps) => (
	<button
		type="button"
		className={`${alwaysVisible && 'zoom-button-always-visible'} mouvement-zoom-button`}
		onClick={onClick}
		data-testid="zoomMouvementDetailsButton"
	>
		<Icon name="MoveDiagonal" iconSet="Lucide" color="white" />
	</button>
);

export default ZoomButton;
